import React, { useContext, useEffect, useState } from "react";
import "./JobCategory.css";
import Telecommunication from "../JobCategory/Images/telecommunication.jpg";
import Health from "../JobCategory/Images/health.jpg";
import HR from "../JobCategory/Images/hr.jpg";
import Finance1 from "../JobCategory/Images/finanance.jpg";
import Finance2 from "../JobCategory/Images/Teacher.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/swiper-bundle.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Autoplay, Navigation, Grid } from "swiper/modules";
import PropTypes from "prop-types";
import industryDummy from "./Images/industryDummy.png";

import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../../../utils/context";
import Common_Title from "../../../common_components/common_title/Common_Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
const JobCategory = ({ alignment }) => {
  const { getData, imageUrl, NoDataAnimations } = useContext(Context);

  const [data, setData] = useState([]);

  const getAllData = async () => {
    const res = await getData("/without-login/home/popular-job");
    setData(res?.data);
  };

  useEffect(() => {
    getAllData();
  }, []);

  const [swiperInstance, setSwiperInstance] = useState(null);
  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const headingStyle = {
    textAlign: alignment === "left" ? "left" : "center",
  };

  const navigate = useNavigate();

  return (
    <>
      <section className="JobCategory">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-lg-12 mx-auto">
              <Common_Title title="Popular " subTitle={" Job Categories"} />

              {/* old swiper */}
              {/* <div className="row mt-4 mb-5">
                <Swiper
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  modules={[Autoplay, Pagination, Grid]}
                  loop={true}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    360: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 10,
                    },
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                >
                  {data?.map((val, index) => (
                    <SwiperSlide key={index}>
                      <div className="card_left-sec card  ">
                        <img
                          src={imageUrl + val?.image}
                          className="card-img-top mx-auto"
                          alt=""
                        />

                        <div className="card-body text-center">
                          <p className="jobcategorytxt card-text mb-3 mt-3">
                            {val?.name}
                          </p>
                        </div>
                        <div className="card-footer p-0">
                          <Link to={`/jobexp?id=${val?.name}`}>
                            <div>
                              <div className="explre_btn_sec">
                                <button className="btn btn-2 hover-slide-up p-0">
                                  <span className="explore_txt">Explore</span>
                                </button>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {data?.length === 0 && <NoDataAnimations />}
                {data?.length !== 0 && (
                  <>
                    <div
                      className="main-slider"
                      onClick={() => handleMainSliderClick("prev")}
                    >
                      <div className="arrow-back" />
                    </div>
                    <div
                      className="main-slider"
                      onClick={() => handleMainSliderClick("next")}
                    >
                      <div className="arrow-next" />
                    </div>
                  </>
                )}
              </div> */}

              <div className="swiper_div">
                <Swiper
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  modules={[Autoplay, Pagination, Grid]}
                  // loop={true}
                  breakpoints={{
                    0: {
                      slidesPerView: 1.1,
                      spaceBetween: 10,
                    },
                    360: {
                      slidesPerView: 1.2,
                      spaceBetween: 10,
                    },
                    640: {
                      slidesPerView: 1.5,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 2.2,
                      spaceBetween: 10,
                    },
                    1024: {
                      slidesPerView: 3.2,
                      spaceBetween: 10,
                    },
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  // autoplay={{
                  //   delay: 2500,
                  //   disableOnInteraction: false,
                  // }}
                >
                  {data
                    ?.reduce((acc, _, i) => {
                      if (i % 2 === 0) acc.push(data.slice(i, i + 2)); // group into pairs
                      return acc;
                    }, [])
                    .map((pair, index) => (
                      <SwiperSlide key={index}>
                        {pair.map((val, idx) => (
                          <div
                            key={idx}
                            className="job_category_div"
                            onClick={() => {
                              navigate(`/jobexp?id=${val?.name}`);
                            }}>
                            <div className="img_holder">
                              <img
                                src={imageUrl + val?.image}
                                className="img_class"
                              />
                            </div>

                            <div className="right_side">
                              <p className="category_name">{val?.name}</p>

                              <div className="box">
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="arrow_icon"
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </SwiperSlide>
                    ))}
                </Swiper>

                {data?.length === 0 && <NoDataAnimations />}
                {data?.length !== 0 && (
                  <>
                    <div
                      className="main-slider"
                      onClick={() => handleMainSliderClick("prev")}>
                      <div className="arrow-back" />
                    </div>
                    <div
                      className="main-slider"
                      onClick={() => handleMainSliderClick("next")}>
                      <div className="arrow-next" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

JobCategory.propTypes = {
  alignment: PropTypes.oneOf(["left", "center"]).isRequired,
};

export default JobCategory;
